import { render, staticRenderFns } from "./ModalSender.vue?vue&type=template&id=7e4ba3b8&"
import script from "./ModalSender.vue?vue&type=script&lang=js&"
export * from "./ModalSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports